/* Contexts.js initalizes the contexts reference and provides it to other modules */

import React from 'react';

const ThemeStateContext = React.createContext();

export {ThemeStateContext};
